import { FormikValues } from 'formik';
import React, { useEffect, useRef, useState } from 'react';

import { Card } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import { CardContent, CardTitle } from '@sierralabs/react-material-ui';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineForm from '../../../common/inline/InlineForm';
import InlineHtml from '../../../common/inline/InlineHtml';
import { InlineFileValue } from '../../../common/inline/InlineFile';
import { FetchError } from '../../../common/api/api';

import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { useUpdateHazard } from '../Hazard.hooks';
import { BaseHazardCardProps, Hazard } from '../Hazard.interface';
import { useUpdateTask } from '../../tasks/Task.hooks';

const HazardImpactCard: React.FC<BaseHazardCardProps> = props => {
  const { hazard, hazardVersion, onChange } = props;
  const formikRef = useRef<FormikValues>();
  const onChangeRef = useRef(onChange);
  const [error, setError] = useState<FetchError | undefined>();
  const { updatedHazard, isUpdating, updateError, updateHazard } =
    useUpdateHazard(hazard.id);
  const {
    updatedTask,
    updateError: updateTaskError,
    updateTask
  } = useUpdateTask(hazard.task.id || 0);
  const { isFieldDisabled } = useTaskEntityFields(hazard.task);
  const disabled = !!hazardVersion;
  const data = hazardVersion || hazard;

  useEffect(() => {
    if (updatedHazard) {
      onChangeRef.current?.(updatedHazard);
    }
  }, [updatedHazard]);
  useEffect(() => {
    if (updatedTask) {
      hazard.task = Object.assign(hazard.task || {}, updatedTask);
      onChange?.(hazard);
    }
  }, [updatedTask]);
  useEffect(() => {
    setError(updateTaskError || updateError);
  }, [updateTaskError, updateError]);

  return (
    <Card>
      <CardTitle>
        <DescriptionIcon />
        Harm
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          error={error}
          isSubmitting={isUpdating}
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{ impact: data.impact || '' }}
          onSubmit={(dto: Partial<Hazard>) => {
            updateHazard(dto);
          }}
        >
          <InlineForm>
            <InlineHtml
              name='impact'
              label='Harm'
              disabled={disabled || isUpdating || isFieldDisabled('harm')}
              helperText='Physical injury or damage to the health of people, or damage to property or the environment.'
              attachments={data.task.attachments || []}
              onChangeAttachments={(attachments: InlineFileValue[]) => {
                updateTask({ attachments });
                if (hazard.task) {
                  hazard.task.attachments = attachments;
                }
                onChange?.(hazard);
              }}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default HazardImpactCard;
